import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const SwiperWrap = styled.div`
  margin-left: -50%;
  margin-right: -50%;
`;

interface IIProps {
  theme: any;
}

export const StyledSwiper = styled.div<IIProps>`
  .swiper-slide > div {
    transition: all 0.2s;
    transform: scale(0.75);
    z-index: 1;
    opacity: 0.4;
  }
  & .swiper-slide-active > div {
    transform: scale(0.95);
    z-index: 2;
    opacity: 1;
  }
`;

export const Wrapper = styled.div`
  padding: 0 0 ${rem(24)};
  overflow: hidden;
`;
export const TitleWrap = styled.div`
  padding: ${rem(32)} ${rem(18)} ${rem(16)};
`;
